<template>
    <page-view title="流程调度">
        <!-- action -->
        <template slot="action">
        </template>
        <a-card>
            <a-form :form="form">
                <table class="fx-form">
                    <tr>
                        <th>流程标题</th>
                        <td>
                            <a-form-item class="form-item-slim">
                                <a-input v-model="queryForm.title" style="width:300px" />
                            </a-form-item>
                        </td>
                        <th>经办人</th>
                        <td>
                            <a-form-item class="form-item-slim">
                                <user-selector @change="onHandlerChange" />
                            </a-form-item>
                        </td>
                    </tr>
                    <tr>
                        <th>登记时间</th>
                        <td>
                            <a-form-item class="form-item-slim">
                                <a-date-picker @change="onChangeDate" />
                            </a-form-item>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" align="center">
                            <a-button type="primary" @click="onSearch">查询</a-button>
                        </td>
                    </tr>
                </table>
            </a-form>
            <p></p>
            <s-table ref="table"
                     :columns="columns"
                     :rowKey="record => record.id"
                     :data="loadData"
                     size="middle">
                <a slot="name" slot-scope="record" @click="onView(record)">{{record.title}}</a>
                <span slot="state" slot-scope="record">
                    <a-tag v-if="record.state === 'C' || record.state === 'D'" color="green">{{record.extras.state}}</a-tag>
                    <a-tag v-else-if="record.state === 'T'" color="red">{{record.extras.state}}</a-tag>
                    <a-tag v-else>{{record.extras.state}}</a-tag>
                </span>
            </s-table>
            <!-- / a-table -->

            <ProcessInstanceManage ref="processInsMgr"/>

        </a-card>
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import UserSelector from '@/components/selector/UserSelector'
import ProcessInstanceManage from './ProcessInstanceManage'
import qs from 'qs'

const columns = [
  {
    title: '文档类别',
    dataIndex: 'cateName',
    width: '150px'
  }, {
    title: '流程状态',
    width: '120px',
    scopedSlots: { customRender: 'state' }
  }, {
    title: '流程名称',
    scopedSlots: { customRender: 'name' }
  }, {
    title: '登记时间',
    dataIndex: 'createDate',
    width: '150px'
  }
]

export default {
  name: 'DictList',
  components: {
    PageView,
    STable,
    UserSelector,
    ProcessInstanceManage
  },
  mounted () {
  },
  data () {
    return {
      columns,
      form: this.$form.createForm(this),
      queryForm: {
        title: '',
        createDate: '',
        handlerId: ''
      },
      queryParams: {},
      loadData: parameter => {
        return this.$http.get('/api/1/workflow/query_process_instance.json', { params: Object.assign(parameter, this.queryParams),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          return res
        })
      },
      refreshing: false,
      modalVisible: false
    }
  },
  methods: {
    onHandlerChange (selectedIds, selectedNames) {
      this.queryForm.handlerId = selectedIds
    },
    onChangeDate (date, dateString) {
      this.queryForm.createDate = dateString
    },
    onSearch () {
      this.queryParams = { ...this.queryForm }
      this.$refs.table.refresh()
    },
    onView (record) {
      this.$refs.processInsMgr.preManage(record.id)
    }
  }
}
</script>

<style scoped lang="less">
    .form-item-slim {
        margin-bottom: 8px
    }
</style>
